<template>
  <div class="loader" :class="{ isLoading }">
    <div class="loader__Inner">
      <div class="loader__Spinner">
        <Icon name="spinner" />
      </div>

      <p class="loader__Text">{{ $t('loader.firstMessage') }}</p>
    </div>
  </div>
</template>

<script setup>
  import { withTrailingSlash } from 'ufo'
  const { isLoading } = useSetup()
  addRouteMiddleware(async (to, from) => {
    if (process.client && withTrailingSlash(to.path) !== withTrailingSlash(from.path)) {
      isLoading.value = true
    }
  })

  useNuxtApp().hook('page:finish', () => {
    isLoading.value = false
  })

  useNuxtApp().hook('app:error', () => {
    isLoading.value = false
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_loading.scss');
</style>
